export default "__VITE_ASSET__3YO8waLS__"